import { gql } from 'react-apollo';
import { full } from '../../../graphql/fragments/user';

export const getCurrentUser = gql`
  query getCurrentUser {
    current_user {
      ...allUserFields
    }
  }

  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/authorization/queries/getCurrentUser.js